import { ref, watch, onBeforeMount } from 'vue';
import { nanoid } from 'nanoid';

export function useIdGenerator(idProp: string | undefined, idPrefix = 'n-input_') {
  const inputId = ref<string>('');

  // Generate a unique ID if none is provided
  function generateId() {
    inputId.value = `${idPrefix}${nanoid()}`;
  }

  // Handle ID changes (equivalent to @Watch)
  watch(
    () => idProp,
    (newId: string | undefined) => {
      inputId.value = newId || `${idPrefix}${nanoid()}`;
    },
    { immediate: true }, // Runs immediately like created()
  );

  // Optional: If you want to ensure it runs before mount
  onBeforeMount(() => {
    if (!idProp) generateId();
  });

  return { inputId };
}
